import { Button, Flex } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../app-state/store';
import { useCurrentColors } from '../../hooks/UseCurrentColors/UseCurrentColors';
import { useCheckForMobileOrTablet } from '../../hooks/UseResponsive/UseResponsive';
import IconButton from '../IconButton/IconButton';
import MobileUsers from './MobileUsers';
import NavMenuItem from './NavMenuItem';
export const getNavBarMaxUsers = (isMobile: boolean) => {
    return isMobile ? 1 : 5;
};
export interface NavbarProps {
    type?: ClientsTypes;
    title: string;
    menu: Array<any>;
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setIsNavBarExpanded: React.Dispatch<React.SetStateAction<boolean>>;
    expansionContent?: React.ReactNode;
    selectedMenu?: any;
    isBannerShown: boolean | null;
    children?: React.ReactNode;
    t: any;
}

const Navbar: React.FC<NavbarProps> = ({
    type = 'portfolio',
    title = 'Dashboard',
    menu = [{ title: 'User Profile', path: 'profile' }],
    children,
    setSidebarOpen,
    expansionContent,
    setIsNavBarExpanded,
    selectedMenu,
    isBannerShown,
    t,
}) => {
    const currentColors = useCurrentColors();
    const [isExpanded, setIsExpanded] = useState(false);
    const dispatch = useDispatch<AppDispatch>();
    const isMobile = useCheckForMobileOrTablet();
    const {
        clients,
        appData: {
            menuStructure: {
                data: { pagesWithSubmenu },
            },
        },
    } = useSelector((state: RootState) => state);

    useEffect(() => {
        if (!expansionContent) {
            setIsNavBarExpanded(false);
            return;
        }
        setIsNavBarExpanded(isExpanded);
    }, [isExpanded, expansionContent]);

    return (
        <>
            <Flex
                as="nav"
                position="fixed"
                right="0px"
                top={isBannerShown ? '75px' : '0px'}
                left={isMobile ? '0' : '80px'}
                zIndex={199}
                backgroundColor={currentColors.navbarBg}
                px={isMobile ? '20px' : '40px'}
                width={isMobile ? '100%' : 'calc(100% - 80px)'}
                height="70px"
                align="center"
                boxSizing="border-box"
                boxShadow={`0px -4px 12px ${currentColors.boxShadow}`}>
                <Flex
                    alignItems="center"
                    flexGrow={0}
                    color={currentColors.navbarTextColor}
                    fontWeight="900"
                    fontSize="22px">
                    {isMobile && (
                        <IconButton
                            background="transparent"
                            cursor="pointer"
                            border="none"
                            width="20px"
                            height="20px"
                            icon="MobileMenu"
                            aria-label="DrawerMenu"
                            mr="16px"
                            backgroundColor="transparent"
                            color={currentColors.brand['300']}
                            variant="ghost"
                            onClick={() => setSidebarOpen(true)}
                            _hover={{
                                backgroundColor: 'transparent',
                            }}
                            _focus={{
                                border: '0px',
                                backgroundColor: 'transparent',
                                outline: 'none',
                            }}
                            _active={{
                                border: '0px',
                            }}></IconButton>
                    )}
                    {title}
                </Flex>
                <Flex>{children}</Flex>
                {expansionContent &&
                    pagesWithSubmenu.includes(selectedMenu) &&
                    selectedMenu !== 'review-all' &&
                    !isMobile && (
                        <Button
                            m="10px"
                            variant="unstyled"
                            fontSize="12px"
                            fontWeight="bold"
                            color={currentColors.whiteAlpha['400']}
                            _focus={{
                                outline: 'none',
                                boxShadow: 'none',
                            }}
                            _hover={{
                                outline: 'none',
                                boxShadow: 'none',
                            }}
                            textTransform="uppercase"
                            onClick={() => setIsExpanded(!isExpanded)}>
                            {isExpanded ? t('show-less') : t('show-more')}
                        </Button>
                    )}
                {expansionContent &&
                    pagesWithSubmenu.includes(selectedMenu) &&
                    selectedMenu !== 'review-all' &&
                    isMobile && (
                        <MobileUsers
                            selectedMenu={selectedMenu}
                            type={type}
                            {...clients[type]}
                            t={t}></MobileUsers>
                    )}
                <Flex flexGrow={1}></Flex>
                <Flex
                    flexGrow={0}
                    position="relative"
                    direction="row-reverse">
                    {menu.map((item: any) => {
                        return (
                            <NavMenuItem
                                menuItem={item}
                                key={item?.key}
                            />
                        );
                    })}
                </Flex>
            </Flex>
            {pagesWithSubmenu.includes(selectedMenu) &&
                selectedMenu !== 'review-all' &&
                isExpanded &&
                !isMobile &&
                expansionContent && (
                    <Flex
                        as="nav"
                        position="fixed"
                        right="0px"
                        top="70px"
                        left={isMobile ? '0' : '80px'}
                        zIndex={100}
                        backgroundColor={currentColors.navbarBg}
                        p="20px"
                        height="60px"
                        width={isMobile ? '100%' : 'calc(100% - 80px)'}
                        align="center">
                        {expansionContent}
                    </Flex>
                )}
        </>
    );
};

export default Navbar;
